import React, { useState, useEffect } from 'react';
import img from "../img/logo3.png"; // Ensure the path to the image is correct
import moon from "../img/moon2.png";
import { Link } from "react-router-dom";

const Navbar = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home'); // Track the active link

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setActiveLink(id); // Set the active link when scrolling
      setMenuOpen(false); // Close the mobile menu when a link is clicked
    }
  };

  // Highlight the current section on scroll
  const handleScrollSpy = () => {
    const sections = ['home', 'about', 'services', 'work', 'contact'];
    const scrollPosition = window.scrollY;

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        const offsetTop = element.offsetTop;
        const offsetHeight = element.offsetHeight;

        if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
          setActiveLink(section);
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScrollSpy);
    return () => {
      window.removeEventListener('scroll', handleScrollSpy);
    };
  }, []);
   let navLink = props.darkMode?'text-orange-500':'text-purple-800';
  return (
    <div className="flex justify-center items-center">
      <nav className="w-10/12 lg:w-8/12 fixed top-4 backdrop-blur-lg bg-white/30 z-50 rounded-2xl border border-white/40 shadow-2xl">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          {/* Logo and Brand Name */}
          <div className="flex items-center gap-2">
            <img src={img} alt="logo" className="w-8 h-8 rounded-lg" />
            <span className={`text-2xl font-bold ${props.darkMode?'text-orange-500':'text-purple-800'}`}>AM-Dev</span>
          </div>

          {/* Desktop Links */}
          <ul className="hidden md:flex space-x-10 text-gray-900 font-bold uppercase text-sm">
            {['home', 'about', 'services', 'work', 'contact'].map((section) => (
              <li key={section} className={`hover:text-gray-400 ${activeLink === section ? navLink : ''}`} onClick={() => handleScroll(section)}>
                <Link to={section === 'home' ? '/' : `/${section}`}>{section.charAt(0).toUpperCase() + section.slice(1)}</Link>
              </li>
            ))}
          </ul>

          {/* Theme Toggle (Moon Icon) */}
          <img src={moon} alt="mode" className="hidden md:block w-6 cursor-pointer" onClick={props.toggleDarkMode} />

          {/* Mobile Menu Toggle Button */}
          <div className="space-y-1 md:hidden cursor-pointer z-20" onClick={() => setMenuOpen(!menuOpen)}>
            <div className="w-6 h-0.5 bg-black"></div>
            <div className="w-6 h-0.5 bg-black"></div>
            <div className="w-6 h-0.5 bg-black"></div>
          </div>
        </div>

        {/* Mobile Menu */}
        <ul className={`${
          menuOpen ? "block" : "hidden"
        } backdrop-blur-3xl bg-white/30 z-50 border border-white/40 shadow-2xl left-0 w-full p-10 rounded-b-3xl space-y-10 text-purple-950 text-center transition-all duration-300 ease-in-out`}>
          {['home', 'about', 'services', 'work', 'contact'].map((section) => (
            <li key={section} className="cursor-pointer" onClick={() => handleScroll(section)}>
              <Link to={section === 'home' ? '/' : `/${section}`}>{section.charAt(0).toUpperCase() + section.slice(1)}</Link>
            </li>
          ))}
        </ul>
      </nav>
      {/* NAVBAR END  */}
    </div>
  );
};

export default Navbar;
